import {
  ModalDialog,
  ModalDialogHeader,
  ModalDialogTitle,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogActions,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'

export interface StartNewServiceConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onGoToExistingJob: () => void
  onContinueAnyway: () => void
  testId?: string
  goToExistingJobTestId?: string
  continueAnywayTestId?: string
}

/**
 * Dialog for confirming whether the user wants to start a new service when they
 * already have a job in progress.
 */
export function StartNewServiceConfirmationDialog({
  isOpen,
  onClose,
  onGoToExistingJob,
  onContinueAnyway,
  testId,
  goToExistingJobTestId,
  continueAnywayTestId,
}: StartNewServiceConfirmationDialogProps) {
  return (
    <ModalDialog isOpen={isOpen} onClose={onClose} testId={testId}>
      <ModalDialogHeader>
        <ModalDialogTitle>
          You already have a tax return in progress
        </ModalDialogTitle>
        <ModalDialogDescription>
          Creating a new job may result in a duplicate tax return. If this was a
          mistake, please return to your existing job instead.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            label="Go to existing job"
            variant="default"
            onPress={onGoToExistingJob}
            testId={goToExistingJobTestId}
          />
          <Button
            variant="outline"
            label="Continue anyway"
            onPress={onContinueAnyway}
            testId={continueAnywayTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
